module.exports = __webpack_public_path__ + "static/img/fuxi.1fc18fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/fuxi.png
// module id = 6LXG
// module chunks = 0